import { combineReducers, Store } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { statisticsMiddleware } from './middleware/statistics';
import { State } from './state';

import { createFirebaseMiddleware } from './middleware/firebase-middleware';
import { firebaseReducers } from './reducers/firebase-reducer';
import { appReducers } from './reducers/app-reducers';
import { studentUIReducers } from './reducers/student-ui-reducers';
import { statisticsReducers } from './reducers/statistics';
import { createAppMiddleware } from './middleware/app-middleware';
import { rosterReducers } from './reducers/roster-reducer';
import { createLoggingDashboardMiddleware } from './middleware/logging-dashboard-middleware';
import { teacherUIReducers } from './reducers/teacher-ui-reducers';
import { adminUIReducers } from './reducers/admin-ui-reducers';

// Define the global state shape!
const reducers = {
  firebase: firebaseReducers,
  app: appReducers,
  roster: rosterReducers,
  adminUI: adminUIReducers,
  studentUI: studentUIReducers,
  teacherUI: teacherUIReducers,
  statistics: statisticsReducers,
};

const middlewares = [
  createFirebaseMiddleware,
  createAppMiddleware,
  statisticsMiddleware,
  createLoggingDashboardMiddleware
];

// Create THE store!
export const store: Store<State> = configureStore(
  // root reducer
  { reducer: combineReducers<State>(reducers), middleware: middlewares }
);

export type ContentStore = Store<State>;
export type AppDispatch = ContentStore['dispatch'];
